"use client";

import { cn } from "../../utils/cn.util";
import { MobileDrawer } from "../drawer/presets";
import { Popover, type PopoverContentProps } from "../popover";
import { useComboboxContext } from "./context";

export type ComboboxContentProps = PopoverContentProps;

const Content = ({ ref, className, children, ...props }: ComboboxContentProps) => {
  const { withoutPopover, label, open, setOpen, isMobile } = useComboboxContext();

  if (withoutPopover) {
    return (
      <div ref={ref} className={cn("overflow-auto rounded-lg border border-neutral-96 bg-white shadow-lg", className)}>
        {children}
      </div>
    );
  }

  if (isMobile) {
    return (
      <MobileDrawer className={className} title={label} open={open} onOpenChange={setOpen}>
        {children}
      </MobileDrawer>
    );
  }

  return (
    <Popover.Content
      ref={ref}
      id="combobox-content"
      className={cn("overflow-auto rounded-lg border border-neutral-96 bg-white shadow-lg", className)}
      {...props}
    >
      {children}
    </Popover.Content>
  );
};

Content.displayName = Popover.Content.displayName || "Content";

export default Content;
